import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import HomePage from './components/HomePage';
import Login from './components/Login';
import Register from './components/Register';
import Contact from './components/Contact';
import Payment from './components/Payment'
import SymbolList from './BusinessDashboard/Symbols/SymbolList';
import BusinessDashboard from './BusinessDashboard/DashBoard';

function App() { //פונקציה ראשית - ריאקט ראוטר (מייצר עמודים שונים באתר)
  return (
    <Router>
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/register" component={Register} />
        <Route path="/contact" component={Contact} />
        <Route path="/payment" component={Payment} />
        <Route path="/Symbol" component={SymbolList} />
        <Route path='/businessDash' component={BusinessDashboard} />
        <Route path="/" component={HomePage} />
      </Switch>
    </Router>


  );
}

export default App;
